<p>
  manual works!
</p>
